import React from 'react'
import img20 from "../assets/img/20.jpg"
import img10 from "../assets/img/10.jpg"
const PointSection = () => {
  return (
    <>
        <div class="content_2_uni_head"  style={{ backgroundImage: `url(${img10})` }}>
    <div>
      <h1>Point Systems</h1>
    </div>
  </div>

  <div class="content_2_about_wrapper">
    <div>
      <div class="content_2_about_sides">
        <div class="inner">
          <header>
          </header>
          <div class="text">
            <p>Get familiar with the aufantasy point system, where every cricket action, from runs to wickets, adds to your success. Understand how to convert your decisions into points and secure a win!</p>
          </div>
        </div>
        <div class="image">
          <img src={img20} alt="Fantasy Point Systems"/>
        </div>
      </div>
    </div>
  </div>
    </>
  )
}

export default PointSection